var _path, _mask, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12134 11.8722L5.12515 11.9593L5.2123 12.9555L6.95542 32.8794L7.04257 33.8756L8.03877 33.7884L49.8789 30.1279L50.8751 30.0407L50.788 29.0445L49.0449 9.12065L48.9577 8.12446L47.9615 8.21161L6.12134 11.8722Z",
    fill: "#0096CC",
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_132_33106",
    maskUnits: "userSpaceOnUse",
    x: 16.8979,
    y: 18.7396,
    width: 34.6495,
    height: 37.3294,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 16.8979,
    y: 18.7396,
    width: 34.6495,
    height: 37.3294
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8846 41.958L30.1629 28.263L29.5969 48.3618L34.8984 42.9553L37.7189 49.6885L40.1327 48.6774L37.3122 41.944L44.8846 41.958Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8846 41.958L30.1629 28.263L29.5969 48.3618L34.8984 42.9553L37.7189 49.6885L40.1327 48.6774L37.3122 41.944L44.8846 41.958Z",
    fill: "#8C8F9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1629 28.263L31.5251 26.7986L28.2881 23.7874L28.1637 28.2067L30.1629 28.263ZM44.8846 41.958L44.8809 43.958L49.981 43.9674L46.2468 40.4936L44.8846 41.958ZM29.5969 48.3618L27.5977 48.3055L27.4541 53.4035L31.0249 49.762L29.5969 48.3618ZM34.8984 42.9553L36.7431 42.1826L35.5793 39.4043L33.4704 41.555L34.8984 42.9553ZM37.7189 49.6885L35.8742 50.4612L36.6469 52.3059L38.4916 51.5332L37.7189 49.6885ZM40.1327 48.6774L40.9054 50.5221L42.7501 49.7494L41.9774 47.9047L40.1327 48.6774ZM37.3122 41.944L37.3159 39.944L34.3037 39.9385L35.4675 42.7167L37.3122 41.944ZM28.8007 29.7273L43.5224 43.4223L46.2468 40.4936L31.5251 26.7986L28.8007 29.7273ZM31.5961 48.4181L32.1621 28.3193L28.1637 28.2067L27.5977 48.3055L31.5961 48.4181ZM33.4704 41.555L28.1689 46.9615L31.0249 49.762L36.3264 44.3555L33.4704 41.555ZM39.5636 48.9158L36.7431 42.1826L33.0537 43.728L35.8742 50.4612L39.5636 48.9158ZM39.36 46.8327L36.9462 47.8438L38.4916 51.5332L40.9054 50.5221L39.36 46.8327ZM35.4675 42.7167L38.288 49.4501L41.9774 47.9047L39.1569 41.1713L35.4675 42.7167ZM44.8883 39.958L37.3159 39.944L37.3085 43.944L44.8809 43.958L44.8883 39.958Z",
    fill: "white",
    mask: "url(#path-2-outside-1_132_33106)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomActions);
export default __webpack_public_path__ + "static/media/custom_actions.d24bbd8c6f6edd6a8efa3b9e2c5c3a86.svg";
export { ForwardRef as ReactComponent };